import { Any, All, Not, Field, Group, ChallengeCompleted, RedeemedReward, BadgeEarned, JoinCode, Tag } from '../types';

export const all = list => All({ $all: list });
export const any = list => Any({ $any: list });
export const not = aql => Not({ $not: aql });

export const hubId = id => Field({
  field: 'hub_id',
  operator: '$exact',
  string_value: id
});

export const group = id => Group({
  group_id: id
});

export const challengeCompleted = id => ChallengeCompleted({
  challenge_completed_id: id
});

export const redeemedReward = id => RedeemedReward({
  reward_redeemed_id: id
});

export const badgeEarned = id => BadgeEarned({
  badge_earned_id: id
});

export const joinCode = code => JoinCode({
  join_code: code
});

export const engagedSince = ms => Field({
  field: 'last_engaged_at',
  operator: '$after',
  milliseconds_ago_value: ms
});

// Atlas Tag-condition helpers. Byte shape matches the server-side
// Conditions::Tag* classes (Spec 006 / 006.1) -- pinned by
// services/hub/spec/unit/lib/targeting/tag_conditions_spec.rb.

export const tagIs = (taxonomyId, termId) => Tag({
  taxonomy_id: taxonomyId,
  operator:    '$tag_is',
  term_id:     termId
});

export const tagIsOneOf = (taxonomyId, termIds) => Tag({
  taxonomy_id: taxonomyId,
  operator:    '$tag_is_one_of',
  term_ids:    termIds
});

export const tagIsAllOf = (taxonomyId, termIds) => Tag({
  taxonomy_id: taxonomyId,
  operator:    '$tag_is_all_of',
  term_ids:    termIds
});

export const tagIsNoneOf = (taxonomyId, termIds) => Tag({
  taxonomy_id: taxonomyId,
  operator:    '$tag_is_none_of',
  term_ids:    termIds
});

export const hasAnyTag = (taxonomyId) => Tag({
  taxonomy_id: taxonomyId,
  operator:    '$has_any_tag'
});

export const hasNoTag = (taxonomyId) => Tag({
  taxonomy_id: taxonomyId,
  operator:    '$has_no_tag'
});
